import { Router } from './router';

new Router();
